export const buildingYourBrandData = {
    blogHeading: 'Building Your Brand',
    blogDate: 'December 19th, 2020',
    mainImage: {
        image: '/images/blog/building-your-brand.jpg',
        alt: 'Building Your Brand'
    },
    webLink: '/blog/building-your-brand',
    description: [
        `
            When you think of a company's brand, what comes to mind? For a lot of people, a company's brand is represented
            by their logo. However, a company's brand is so much more than the logo. The company's brand is the way you experience
            them—the quality of their product, logo, website, store, or even the way their staff interacts with you. Take a minute and
            think about some of the companies that you like. Why do you like them? Is there a fond memory you have of your
            interaction. Maybe it's a product of theirs that you own that enhances your life. Understanding brand is important, because you
            are a brand unto yourself in the field of web development. 
        `,

        `<h2>Your Brand, Your Career</h2>`,

        `A developer who is able to understand and manage their brand has the ability to shape their career. This may
         sound like a rather bold statement, but we have a service to offer, and clients (or, companies) seek us out to
         make use of them. In this industry, no two developers are alike. We possess a myriad of skill sets, and every
         developer tackles problems differently. This is great for us, because developers whom are able to differentiate themselves
         from the typical development crowd can easily stand out. In this article, we'll discuss some ways to craft your brand
         via skills, presentation, and experience.
         `,

        `<h2>Skills</h2>`,

        `Your skills make up a large part of your brand. This tends to be what companies focus upon, as they often have a
        need of someone who can work within a specific tech stack. It makes little sense to hire a developer who specializes in .NET,
        when a company is looking for someone with skills in JAVA. Your skills are your bread and butter, so it is important
        for you to build your skills up carefully. This article won't discuss the type of skills to possess. Rather, research the market
        to find what is being asked for, and develop those skills. It is best to be strong in certain areas where your interests lie. Are you
        a backend developer? A data specialist? Or maybe a front end developer? Each of these areas denote a different area
        of specialization, which can be of value to companies. As skillsets are the largest part companies look for, it is best to
        make them the most readily available. As an example, I have my own 'Skills' page set out in this website for easy access.
        `,

        `<h2>Presentation</h2>`,

        `Just as a company's storefront is part of it's brand, so is the way you present yourself. If you walk into a dirty
        restaurant, how would you feel about the safety of the food? This applies to developers in how they present themselves
        to companies. Is your resume messy, or your website confusing to navigate? Do you dress sloppily, or overdress compared to
        the company dress code? Does your code tend to be buggy, or is your work clean and polished? All of these things, and more
        build a picture to others as to who you are. While you don't need to exhaust yourself worrying about other's perception
        of yourself, being mindful of these things can help you craft other's perception.
        `,

        `<h2>Experience</h2>`,

        `Can you recall a company where you had a bad experience? Maybe it was with a customer service representative that
        wasn't very helpful. Do you avoid this company to this day because of that bad experience? We have the same ability to craft a 
        good (or bad) experience with other people through the way they interact with us. Have you ever heard of a developer
        who is very talented, but difficult to work with? Or maybe that a developer is a nice person, but struggles getting their
        work done on time. All of experiences make up a developer's brand, which can impact how people view them. A strong brand
        can create a deeper desire from the company to pull a developer hire. Or, a weak brand can do the opposite—even to the point of 
        a company parting ways with a developer. I'm not advocating that you need to have a smile and roll over for everybody around you—no one likes
        a people pleaser. But, you should be mindful of how well you work with others impacts your brand.
        `,

        `<h2>Wrapping Things Up</h2>`,

        `Building a great brand can take years, but losing it can be gone in minutes. For developers who want to enhance their career,
        being mindful of their brand can help them go a long way. If you doubt the power of a strong brand, think of all of the emotions
        and memories that are evoked just from seeing the logo of your favorite company. The same can be said of you for companies, and those
        around you. Do people silently groan when you enter a room? Or, do people look forward to having you on a project. I'll let you in on a secret:
        The stronger your brand, the more your perceived value is. This is why companies are often willing to pay thousands to hundreds of thousands
        of dollars for a strong logo to represent their brand. If companies look at your brand, and perceive you to be inexperienced or prone
        to errors, they are not going to offer very competitive rates for your service. However, if the company sees you have a strong background
        working on high end projects and a strong reputation, they will be willing to offer competitive rates for your service. While we as developers
        don't have control over everything, we do have the ability to craft our brand, and shape our career.
        `
    ]
}